import { Box, Button, Card, MenuItem, Typography, useMediaQuery } from '@mui/material'
import { IconCopy, IconLink, IconShare } from '@tabler/icons-react'
import { theme } from '~/utils'
import { PaperPlaneWithMail } from '~/assets/illustrations'
import { copyToClipboard } from '~/utils/clipboard'
import { Dropdown, ShareSocialMediaLinks } from '~/components'
import { useAuth } from '~/contexts'
// import { usePartner } from '~/contexts'

export const ReferralLinkBanner: React.FC = () => {
  // const { indicationLink, myPartner } = usePartner()
  const { authUser } = useAuth()

  const isLowerSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isLowerMd = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box sx={{
      gap: 3,
      padding: isLowerSm ? 2 : 4,
      display: 'flex',
      background: '#FFFBE5',
      borderRadius: '12px',
      position: 'relative',
      flexDirection: 'column',
      border: '1px solid #F9DC45',
      flexGrow: 1
    }}>
      {!isLowerSm && <PaperPlaneWithMail style={{ position: 'absolute', top: '0px', right: '16px', fontSize: 150 }} />}

      <Box sx={{
        padding: 2,
        display: 'flex',
        borderRadius: '8px',
        alignItems: 'center',
        width: 'fit-content',
        background: '#FFF2AD',
        justifyContent: 'center',
        maxHeight: '55px'
      }}>
        <IconLink />
      </Box>

      <Typography variant='h6' fontWeight={600}>
        Amigo Indica Amigo Desperta Energia
      </Typography>

      <Typography sx={{ fontSize: isLowerSm ? '16px' : '18px', lineHeight: isLowerSm ? '150%' : '30px', maxWidth: isLowerSm ? '100%' : '100%' }}>
        Indique clientes, beneficie seus amigos, e ainda ganhe mais! <br />Quanto mais clientes você indicar, maiores são suas recompensas, e maiores os benefícios de quem você indicar.
      </Typography>
      <Typography fontWeight={500} color={theme.palette.yellow.darker} sx={{ fontSize: isLowerSm ? '14px' : '16px', lineHeight: isLowerSm ? '150%' : '30px', maxWidth: isLowerSm ? '100%' : '100%' }}>
        Simples assim: indicou, virou cliente, você ganha 😉
      </Typography>

      <Box sx={{
        gap: 3,
        display: 'flex',
        alignItems: 'start',
        flexFlow: isLowerSm ? 'column' : 'row',
        paddingBottom: isLowerSm ? '3rem' : '0'
      }}>
        <Box onClick={() =>

          copyToClipboard(process.env.VITE_APP_ENV === 'production' ?
            `https://despertaenergia.com/indicacao?c=${authUser?.indicationCode}`
            :
            `https://alpha--desperta-landing.netlify.app/indicacao?c=${authUser?.indicationCode}`
          )
        }
          sx={{ maxWidth: '180px' }}>
          <Button sx={{ boxSizing: 'content-box', padding: '.75rem 1.6rem' }} startIcon={<IconCopy size={24} />}>
            COPIAR LINK
          </Button>
        </Box>
        <ShareSocialMediaLinks />
      </Box>

    </Box >
  )
}
